module.exports = __webpack_public_path__ + "static/img/3.4c2f588.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/6/1/eng/3.png
// module id = j0aE
// module chunks = 0